<template>
  <div class="container">
    <div class="survey-wrap">
      <ul class="survey-list">
        <li class="survey-question" v-for="(result,i) in surveyData.survey_result">
          <p>
            {{result.question_title}}
          </p>
          <p class="txt-option">{{result.option_text}}</p>
        </li>
      </ul>
    </div>

    <div class="fixed-footer" style="padding:12px;">
      <van-button type="default" size="large" @click="$router.push('/')" >返回主页</van-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .survey-wrap {
    margin-bottom: 72px;
    .survey-list {
      .survey-question {
        padding: 12px;
        background-color: #fff;
        border-bottom: 1px solid rgba(0,0,0,.1);
        p {
          padding: 8px;
          font-size: 14px;
        }
        .txt-option{
          color: #666666;
        }
      }
    }
  }
</style>

<script>
  import * as survey_api from '@/api/survey.js';
  export default {
    data() {
      return {
        surveyData: {},
      }
    },
    mounted() {
      var surveyId = this.$route.query.id;
      survey_api.getUserSurveyDetail(surveyId).then(res => {
        this.surveyData = res.data;
        console.log(this.surveyData);
      })
    },
  }
</script>